import React from 'react'
import PropTypes from 'prop-types'
import Label from './Label'
import useInput from '../../hooks/useInput'

export default function CheckboxInput ({
  name, multiple, label, value, subobj, toggleAble
}) {

  const { getValue, setValue, addValue, removeValue, contains } = useInput()

  const input = React.createRef()

  const handleOnClick = function () {
    handleOnChange()
  }

  const handleOnChange = function () {
    let newCheckedState = !input.current.checked

    if (multiple) {
      if (newCheckedState === true) {
        addValue(name, value, subobj)
      } else {
        removeValue(name, value, subobj)
      }
    } else {
      setValue(name, value ?? newCheckedState, subobj)
    }
  }

  return (
    <div className={'checkbox'} onClick={handleOnClick}>
      <Label>
        <input type={'checkbox'}
               checked={contains(name, value, subobj)}
               ref={input}
               // onChange={handleOnChange}
        />
        <span>
          {label}
        </span>
      </Label>
    </div>
  )
}

CheckboxInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func

}